import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { MessageBubble, Loader } from 'widget/components/common'

class TypingPlaceholder extends PureComponent {
  render() {
    if(this.props.active === false) {
      return null
    }

    return (
      <Container>
        {
          this.props.avatarBot &&
          <Avatar src={this.props.avatarBot} alt="avatar" />
        }
        <TypingContainer>
          <Loader />
        </TypingContainer>
      </Container>
    )
  }
}

TypingPlaceholder.propTypes = {
  active: PropTypes.bool
}

export default TypingPlaceholder

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  margin: 0px 3px;
  font-size: 14px;
`

const Avatar = styled.img`
  width: 40px;
  height: 40px;
  margin-right: 5px;
`

const TypingContainer = styled(MessageBubble)`
  background-color: ${props => props.theme.botBubbleBG};
  text-align: center;
  ${({theme}) => theme.bot_msg_container_css}
`




// WEBPACK FOOTER //
// ./src/ChatWidget/components/Messages/TypingPlaceholder.js